// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pCPVb","list":"styles_list__1v7xx","disableSelection":"styles_disableSelection__r4QCf"};